__turbopack_context__.v({
  "animateIn": "FlavorProfileGraph-module-scss-module__Dbbt_q__animateIn",
  "chartPoly": "FlavorProfileGraph-module-scss-module__Dbbt_q__chartPoly",
  "chartPolyGroup": "FlavorProfileGraph-module-scss-module__Dbbt_q__chartPolyGroup",
  "chartPolyline": "FlavorProfileGraph-module-scss-module__Dbbt_q__chartPolyline",
  "circle": "FlavorProfileGraph-module-scss-module__Dbbt_q__circle",
  "circleGroup": "FlavorProfileGraph-module-scss-module__Dbbt_q__circleGroup",
  "end": "FlavorProfileGraph-module-scss-module__Dbbt_q__end",
  "fade-in": "FlavorProfileGraph-module-scss-module__Dbbt_q__fade-in",
  "graph": "FlavorProfileGraph-module-scss-module__Dbbt_q__graph",
  "graphInner": "FlavorProfileGraph-module-scss-module__Dbbt_q__graphInner",
  "hasInViewAnimation": "FlavorProfileGraph-module-scss-module__Dbbt_q__hasInViewAnimation",
  "label": "FlavorProfileGraph-module-scss-module__Dbbt_q__label",
  "labelInner": "FlavorProfileGraph-module-scss-module__Dbbt_q__labelInner",
  "labelsPadding": "FlavorProfileGraph-module-scss-module__Dbbt_q__labelsPadding",
  "middle": "FlavorProfileGraph-module-scss-module__Dbbt_q__middle",
  "numbers": "FlavorProfileGraph-module-scss-module__Dbbt_q__numbers",
  "points": "FlavorProfileGraph-module-scss-module__Dbbt_q__points",
  "start": "FlavorProfileGraph-module-scss-module__Dbbt_q__start",
});
